<template>
  <div>
    <br />
    <!-- The store's record is still null on the first render when a task is opened: show nothing until it
         arrives, or every activity.subject below throws (Chrome run 30/10, null 'subject'). -->
    <div v-if="activity" class="p-fluid">
      <h5 class="center">Main {{ noun }} Info</h5>
      <br />
      <!-- A task shows what the New Task form offers (ActivityForm in task mode), in its wording,
           plus the result and result notes it is completed with. A meeting's fields follow. -->
      <template v-if="isTask">
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="Subject">Subject *</label>
            <InputText
              class="clearer"
              id="subject"
              v-model.trim="activity.subject"
              :disabled="true"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="user">Created For</label>
            <InputText
              class="clearer"
              v-model="user.fullName"
              :disabled="true"
            />
          </div>
          <div class="p-field p-col">
            <label for="activityDate">Task Date*</label>
            <Calendar
              class="clearer"
              id="dateCreated"
              v-model="activity.dateCreated"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              :disabled="true"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="activityType">Type</label>
            <InputText
              class="clearer"
              id="activityType"
              :value="typeName"
              :disabled="true"
            />
          </div>
          <div class="p-field p-col">
            <label for="mbpBranch">MBP Branch</label>
            <InputText
              class="clearer"
              v-model="mbpBranch.branchName"
              :disabled="true"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="customer">Customer</label>
            <InputText
              class="clearer"
              :disabled="true"
              v-model="customer.custName"
            />
          </div>
          <div class="p-field p-col">
            <label for="contact">Contact</label>
            <InputText
              class="clearer"
              v-model="contact.contactName"
              :disabled="true"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="quote">Quotation</label>
            <InputText
              class="clearer"
              :disabled="true"
              :value="activity.quote ? activity.quote.quoteVer : ''"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="notes">Notes</label>
            <Textarea
              class="clearer"
              id="notes"
              v-model="activity.notes"
              :autoResize="true"
              rows="3"
              :disabled="true"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="result">Task Result</label>
            <InputText
              class="clearer"
              id="result"
              v-model="activityResult.resultDesc"
              :disabled="true"
            />
          </div>
        </div>
        <div class="p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="resultNotes">Result notes</label>
            <Textarea
              class="clearer"
              id="resultNotes"
              v-model="activity.resultNotes"
              :autoResize="true"
              rows="3"
              :disabled="true"
            />
          </div>
        </div>
      </template>
      <template v-else>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="Subject">Subject *</label>
          <InputText
            class="clearer"
            id="subject"
            v-model.trim="activity.subject"
            required="true"
            autofocus
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="user">Created For</label>
          <InputText
            class="clearer"
            v-model="user.fullName"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="activityDate">{{ noun }} Date*</label>
          <Calendar
            class="clearer"
            id="dateCreated"
            v-model="activity.dateCreated"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mbpBranch">MBP Branch</label>
          <InputText
            class="clearer"
            v-model="mbpBranch.branchName"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="quote">Quotation</label>
          <InputText
            v-if="activity.quote"
            class="clearer"
            placeholder="Click button to search for customer"
            :disabled="true"
            v-model="activity.quote.quoteVer">
          </InputText>
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="customer">Customer</label>
          <InputText
            class="clearer"
            placeholder="Click button to search for customer"
            :disabled="true"
            v-model="customer.custName">
          </InputText>
        </div>
        <div class="p-field p-col">
          <label for="contact">Contact</label>
          <InputText
            class="clearer"
            v-model="contact.contactName"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes</label>
          <InputText
            class="clearer"
            id="phoneNo"
            v-model.trim="activity.notes"
            required="false"
            autofocus
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="meetingNotes">Meeting Notes</label>
          <!-- G5: editable at any time on an open or completed event, saved on its own -->
          <Textarea
            class="clearer"
            id="meetingNotes"
            v-model="meetingNotesDraft"
            :autoResize="true"
            rows="5"
            :disabled="!notesEditable"
          />
          <Button
            v-if="notesEditable"
            id="saveMeetingNotes"
            label="Save meeting notes"
            icon="pi pi-check"
            class="p-button-sm p-mt-2"
            style="width: auto"
            :disabled="!notesChanged || savingNotes"
            @click="saveMeetingNotes"
          />
          <!-- <InputText
            class="clearer"
            id="meeting Notes"
            v-model.trim="activity.resultNotes"
            required="false"
            autofocus
            :disabled="true" 
          /> -->
        </div>
        <div class="p-field p-col">
          
          <div class="p-fluid">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col">
                <label for="custRef">Status Comment</label>
                <InputText
                  class="clearer"
                  id="statusComment"
                  v-model.trim="activity.statusComment"
                  required="false"
                  autofocus
                  :disabled="true"
                />
              </div>
            </div>
            <div class="p-formgrid p-grid">
              <div class="p-field p-col">
                <label for="result">{{ noun }} Result</label>
                <InputText
                  class="clearer"
                  v-model="activityResult.resultDesc"
                  :disabled="true"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
      </template>
      
      <br />

      <h5 class="center">{{ isTask ? "When" : "Event Timing" }}</h5>
      <br />
      
      <!-- <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <ToggleButton v-model="activityTimingSection" :onLabel="`Show ${noun.toLowerCase()} timing section`" :offLabel="`Hide ${noun.toLowerCase()} timing section`" onIcon="pi pi-file" offIcon="pi pi-times" />
        </div>
      </div> -->

      <div class="p-formgrid p-grid" v-if="!activityTimingSection">
        <div class="p-field p-col">
          <label for="startDate">{{ isTask ? "When*" : "Start Date*" }}</label>
          <Calendar
            class="clearer"
            id="startDate"
            v-model="activity.startDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="startTime">{{ isTask ? "Time*" : "Start Time*" }}</label>
          <Calendar
            class="clearer"
            id="startTime"
            v-model="activity.startTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="true"
          />
        </div>
      </div>
      <!-- A task has a When and nothing else: no end (a stored one is kept, just not shown). -->
      <div class="p-formgrid p-grid" v-if="!activityTimingSection && !isTask">
        <div class="p-field p-col">
          <label for="endDate">End Date*</label>
          <Calendar
            class="clearer"
            id="endDate"
            v-model="activity.endDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="endTime">End Time*</label>
          <Calendar
            class="clearer"
            id="endTime"
            v-model="activity.endTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="true"
          />
        </div>
      </div>
      <br />

      <h5 class="center">{{ noun }} Reminder</h5>
      <br />
      
      <!-- <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <ToggleButton v-model="activityReminderSection" :onLabel="`Show ${noun.toLowerCase()} reminder section`" :offLabel="`Hide ${noun.toLowerCase()} reminder section`" onIcon="pi pi-file" offIcon="pi pi-times" />
        </div>
      </div> -->
      
      <!-- <div class="p-formgrid p-grid" v-if="!activityReminderSection">
        <div class="p-field p-col">
          <label for="deadlineDate">Deadline Date*</label>
          <Calendar
            class="clearer"
            id="deadlineDate"
            v-model="activity.deadlineDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="deadlineTime">Deadline Time*</label>
          <Calendar
            class="clearer"
            id="deadlineTime"
            v-model="activity.deadlineTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="true"
          />
        </div>
      </div> -->
      <div class="p-formgrid p-grid" v-if="!activityReminderSection">
        <div class="p-field p-col">
          <label for="reminder">Create Reminder?</label>
          <br />
          <span v-if="activity.reminder">Yes</span>
          <span v-else>No</span>
        </div>
        <div class="p-field p-col">
          <label for="activity.reminderType">Reminder Type</label>
          <InputText
            class="clearer"
            v-model="reminderType.reminderTypeName"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid" v-if="!activityReminderSection">
        <div class="p-field p-col">
          <label for="reminderDate">Reminder Date*</label>
          <Calendar
            class="clearer"
            id="reminderDate"
            v-model="activity.reminderDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="reminderTime">Reminder Time*</label>
          <Calendar
            class="clearer"
            id="reminderTime"
            v-model="activity.reminderTime"
            :showIcon="true"
            :showTime="true"
            :timeOnly="true"
            hourFormat="24"
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-6 p-md-6">
          <label for="createdBy">Created By:</label>
          <InputText
            v-if="activity.createdBy"
            class="clearer"
            type="text"
            placeholder=""
            :disabled="true"
            v-model="activity.createdBy.fullName"
          ></InputText>
          <InputText
            v-else
            type="text"
            placeholder=""
            :disabled="true"
          ></InputText>
        </div>
        <div class="p-field p-col-6 p-md-6">
          <label for="created">Date Created:</label>
          <InputText
            class="clearer"
            type="text"
            placeholder=""
            :disabled="true"
            v-model="activity.dateCreated"
          ></InputText>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-6 p-md-6">
          <label for="updatedBy">Updated By:</label>
          <InputText
            v-if="activity.updatedBy"
            class="clearer"
            type="text"
            placeholder=""
            :disabled="true"
            v-model="activity.updatedBy.fullName"
          ></InputText>
          <InputText
            v-else
            type="text"
            placeholder=""
            :disabled="true"
          ></InputText>
        </div>
        <div class="p-field p-col-6 p-md-6">
          <label for="updated">Date Updated:</label>
          <InputText
            class="clearer"
            type="text"
            placeholder=""
            :disabled="true"
            v-model="activity.dateUpdated"
          ></InputText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { kindOfRecord } from "@/mbp/activityKind";
import ActivityService from "@/service/ActivityService";

export default {
  data: () => ({
    activityTimingSection: false,
    activityReminderSection: false,
    activityResult: {},
    user: {},
    activityType: {},
    mbpBranch: {},
    customer: {},
    contact: {},
    activityStatus: {},
    reminderType: {},
    meetingNotesDraft: '',
    savingNotes: false
  }),
  created() {
    this.setupComponent(this.$store.getters['activities/getActivityForTabs'])
  },
  computed: {
    activity() {
      return this.$store.getters['activities/getActivityForTabs']
    },
    // A task (kind TASK: Call, Email, Task) is labelled "Task"; a Meeting keeps "Activity".
    isTask() {
      return kindOfRecord(this.activity) === 'TASK'
    },
    noun() {
      return this.isTask ? 'Task' : 'Event'
    },
    // G5: an event's meeting notes can be changed while it is open or completed, not once cancelled
    notesEditable() {
      const status = this.activity && this.activity.activityStatus && this.activity.activityStatus.statusName
      return !this.isTask && status !== 'Cancelled'
    },
    notesChanged() {
      return this.meetingNotesDraft !== ((this.activity && this.activity.resultNotes) || '')
    },
    // The type the task form shows: the record's type, or a list row's flat type name.
    typeName() {
      const a = this.activity || {}
      return (a.activityType && a.activityType.activityTypeName) || a.activityTypeName || ''
    }
  },
  watch: {
    activity(val) {
      this.setupComponent(val)
    }
  },
  methods: {
    saveMeetingNotes() {
      const notes = this.meetingNotesDraft
      this.savingNotes = true
      return new ActivityService()
        .updateMeetingNotes(this.activity.activityId, notes)
        .then(() => {
          this.activity.resultNotes = notes.trim() || null
          this.meetingNotesDraft = this.activity.resultNotes || ''
          this.$toast.add({ severity: 'success', summary: 'Saved', detail: 'Meeting notes saved.', life: 3000 })
        })
        .catch(() => {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'The meeting notes were not saved.', life: 5000 })
        })
        .finally(() => { this.savingNotes = false })
    },
    setupComponent(val) {
      this.meetingNotesDraft = (val && val.resultNotes) || ''
      if (val && val.activityResult) {
        this.activityResult = val.activityResult
      }
      if (val && val.user) {
        this.user = val.user
      }
      if (val && val.activityType) {
        this.activityType = val.activityType
      }
      if (val && val.mbpBranch) {
        this.mbpBranch = val.mbpBranch
      }
      if (val && val.customer) {
        this.customer = val.customer
      }
      if (val && val.contact) {
        this.contact = val.contact
      }
      if (val && val.activityStatus) {
        this.activityStatus = val.activityStatus
      }
      if (val && val.reminderType) {
        this.reminderType = val.reminderType
      }
    }
  }
}
</script>

<style>

</style>